import React from 'react';
export function Footer() {
  return <footer className="bg-brand-mint text-gray-400 text-center py-6 px-4 text-xs font-medium tracking-wider" data-id="element-59">
      Código Sensorial TEA® © 2025 · Todos los derechos reservados · Política
      de privacidad · Garantía 60 días
    </footer>;
}